"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.download = download;
exports.downloadByBom = downloadByBom;
exports.initData = initData;

var _request = _interopRequireDefault(require("@/utils/request"));

var _qs = _interopRequireDefault(require("qs"));

function initData(url, params) {
  return (0, _request.default)({
    url: url + '?' + _qs.default.stringify(params, {
      indices: false
    }),
    method: 'get'
  });
}

function download(url, params) {
  return (0, _request.default)({
    url: url + '?' + _qs.default.stringify(params, {
      indices: false
    }),
    method: 'get',
    responseType: 'blob'
  });
}

function downloadByBom(url, data) {
  return (0, _request.default)({
    url: url,
    method: 'post',
    responseType: 'blob',
    data: data
  });
}